import * as Yup from 'yup';

export interface EvaluationLessonForm {
    name: string;
    description?: string;
    mainImage?: string;
    author: string;
    prerequisites: boolean;
    mandatory: boolean;
    saveHighestScore: boolean;
    lockAfterApproval: boolean;
    shuffleAlternatives: boolean;
    showResponseSummary: boolean;
    masteryScore: number;
    gradeWeight?: number;
    maxTries: number;
    timeLimit?: number;

    incGradeWeight: boolean;
    incTimeLimit: boolean;
    questionsAmount: number;
}

export const evaluationlessonSchema: Yup.ObjectSchema<EvaluationLessonForm> = Yup.object().shape<EvaluationLessonForm>({
    name: Yup.string().required(),
    description: Yup.string().notRequired(),
    author: Yup.string().required(),
    mainImage: Yup.string().notRequired(),

    prerequisites: Yup.boolean().required(),
    mandatory: Yup.boolean().required(),
    saveHighestScore: Yup.boolean().required(),
    lockAfterApproval: Yup.boolean().required(),
    shuffleAlternatives: Yup.boolean().required(),
    showResponseSummary: Yup.boolean().required(),
    masteryScore: Yup.number()
        .integer()
        .min(10)
        .max(100)
        .required(),

    maxTries: Yup.number()
        .integer()
        .min(1)
        .max(99)
        .required(),
    incGradeWeight: Yup.boolean().required(),
    incTimeLimit: Yup.boolean().required(),
    gradeWeight: Yup.number().when('incGradeWeight', {
        is: true,
        then: Yup.number().required(),
        else: Yup.number().notRequired(),
    }),
    timeLimit: Yup.number().when('incTimeLimit', {
        is: true,
        then: Yup.number().required(),
        else: Yup.number().notRequired(),
    }),
    questionsAmount: Yup.number().when('$totalQuestions', (totalQuestions: number) =>
        Yup.number()
            .integer()
            .min(1)
            .max(totalQuestions)
            .required(),
    ),
});

export const formInitialState = {
    '@class': '.LessonContentTO',
    name: '',
    description: '',
    mainImage: undefined,
    author: '',
    prerequisites: false,
    mandatory: true,
    saveHighestScore: false,
    lockAfterApproval: false,
    shuffleAlternatives: false,
    showResponseSummary: false,
    masteryScore: 70,
    gradeWeight: 1,
    maxTries: 1,
    timeLimit: 0,
    incGradeWeight: true,
    incTimeLimit: false,
    questionsAmount: 0,
};
